/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiProjectsIdMutationResponse,
  DeleteApiProjectsIdPathParams,
} from '../models/DeleteApiProjectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiProjectsIdMutationResponseSchema } from '../zod/deleteApiProjectsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiProjectsIdMutationKey = () =>
  [{ url: '/api/projects/:id' }] as const;

export type DeleteApiProjectsIdMutationKey = ReturnType<
  typeof deleteApiProjectsIdMutationKey
>;

/**
 * {@link /api/projects/:id}
 */
export async function deleteApiProjectsId(
  id: DeleteApiProjectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/projects/${id}`,
    ...requestConfig,
  });
  return deleteApiProjectsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projects/:id}
 */
export function useDeleteApiProjectsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiProjectsIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiProjectsIdPathParams['id'] },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiProjectsIdMutationKey();

  return useMutation<
    DeleteApiProjectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiProjectsIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiProjectsId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
